import styled from 'styled-components';
import noop from 'utils/noop';
import RCSlider from 'rc-slider';
import { spacing } from 'ui/theme';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import type { Fraction } from '../../../types';

const Container = styled.div`
  padding: ${spacing.base};
  width: 100%;
`;

const RangeContainer = styled.div`
  display: grid;
  gap: ${spacing.quarter};
  grid-template-columns: 4fr 1fr;
  place-items: center end;
  .rc-slider {
    /** overriding rc-slider default styling */
    margin-top: 0;
  }
`;

const PercentageInput = styled(InputText)`
  max-width: 65%;
  overflow: hidden;
`;

type Props = {
  isOrg: boolean;
  onChange: (value: Fraction['value'], percentageValue: Fraction['percentageValue']) => void;
  percentageValue: Fraction['percentageValue'];
  value: Fraction['value'] /** The org/project id. */;
};

export const FractionalInputBox = ({ onChange = noop, percentageValue, value, isOrg }: Props) => {
  const handlePercentageValue = (newPercentage: string) => {
    let newPercentageValue = parseFloat(newPercentage || '0');
    if (Number.isNaN(newPercentageValue) || newPercentageValue < 0) {
      newPercentageValue = 0;
    } else if (newPercentageValue > 100) {
      newPercentageValue = 100;
    }
    onChange(value, newPercentageValue / 100);
  };

  const handleChangeSlider = (fractionalValue: number) => {
    if (fractionalValue >= 0 && fractionalValue <= 100) {
      onChange(value, fractionalValue / 100);
    }
  };

  return (
    <Container>
      <FormField labelText={isOrg ? 'Org ID' : 'Project ID'} inputId={value}>
        <InputText
          data-test="fractional-input-box-value-input"
          id={value}
          onChange={(newValue: string) => onChange(newValue, percentageValue)}
          value={value}
        />
      </FormField>

      <FormField labelText="Percentage enabled" inputId={`${value}-percentage-input`}>
        <RangeContainer>
          <RCSlider value={Math.round(percentageValue * 100)} onChange={handleChangeSlider} />
          <PercentageInput
            data-test="fractional-input-box-percentageValue-input"
            id={`${value}-percentage-input`}
            onChange={handlePercentageValue}
            value={`${Math.round(percentageValue * 100)}`}
          />
        </RangeContainer>
      </FormField>
    </Container>
  );
};
